// Mirrors `drizzle-orm/expo-sqlite/index.js` — re-exports from `driver`.
// `migrator` is exposed as a sub-path in `package.json`, matching
// `drizzle-orm/expo-sqlite/migrator`.

export { drizzle, type ExpoSQLiteAsyncDatabase } from "#expo-sqlite-async/driver";
